// Hook: loads the LIVE seasonal section-availability blocks from the
// section_blocks table (db-39; see src/data/sectionBlocks.ts + the pure logic in
// src/services/sectionBlocks.ts). Mirrors the useNextStepsTemplates cache
// pattern: 5-minute module-level cache so the wizard doesn't refetch per mount;
// the admin editor invalidates on save/edit/deactivate.

import React from "react";
import { listLiveSectionBlocks } from "../data/sectionBlocks";
import type { SectionBlock } from "../services/sectionBlocks";

let _cached: SectionBlock[] | null = null;
let _cacheTime = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export function useSectionBlocks(): { blocks: SectionBlock[]; isLoaded: boolean } {
  const [blocks, setBlocks] = React.useState<SectionBlock[]>(_cached || []);
  const [isLoaded, setLoaded] = React.useState(!!_cached);

  React.useEffect(function () {
    if (_cached && Date.now() - _cacheTime < CACHE_TTL) {
      setBlocks(_cached);
      setLoaded(true);
      return;
    }
    listLiveSectionBlocks().then(function (value) {
      const result = Array.isArray(value) ? value : [];
      _cached = result;
      _cacheTime = Date.now();
      setBlocks(result);
      setLoaded(true);
    });
  }, []);

  return { blocks, isLoaded };
}

export function invalidateSectionBlocksCache(): void {
  _cached = null;
  _cacheTime = 0;
}
